import { render } from "./text-cell.vue?vue&type=template&id=4dba2813&scoped=true"
import script from "./text-cell.vue?vue&type=script&lang=js"
export * from "./text-cell.vue?vue&type=script&lang=js"

import "./text-cell.vue?vue&type=style&index=0&id=4dba2813&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dba2813"]])

export default __exports__